exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-dialog{\r\n  overflow: auto;\n}\r\n", ""]);

// exports
